import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M20.25 6.75V19C20.25 19.6904 19.6904 20.25 19 20.25H6.75" vectorEffect="non-scaling-stroke" />
		<Path d="M17.25 12.596L14.2948 9.6397C14.2558 9.60064 14.1925 9.60063 14.1534 9.63969L10.5584 13.2347C10.5245 13.2686 10.4713 13.2737 10.4316 13.2469L7.39239 11.1909C7.35761 11.1674 7.31184 11.1681 7.27781 11.1927L3.75 13.7408M17.25 12.596V5C17.25 4.30964 16.6904 3.75 16 3.75H5C4.30964 3.75 3.75 4.30964 3.75 5V13.7408M17.25 12.596V16C17.25 16.6904 16.6904 17.25 16 17.25H5C4.30964 17.25 3.75 16.6904 3.75 16V13.7408" vectorEffect="non-scaling-stroke" />
	</SVG>
);
